import React, { useEffect, useRef } from "react";
import { isCordovaAvailable } from "../../../../../app/src/Utils/secureStorageUtil";


const BannerHTMLComponent = ({ playlist, title }) => {
    const containerRef = useRef(null);
    const isMobile = isCordovaAvailable();
    const bannerContent = playlist[0]?.codigo_html ?? null;
    const openSystemBrowser = (url) => {
      if (window?.cordova?.InAppBrowser) {
        window.cordova.InAppBrowser.open(url, "_system");
        return;
      }
      window.open(url, "_blank");
    };

        useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleLinkClick = (e) => {
            const link = e.target.closest('a');
            if (link && link.href) {
                const url = link.href;
                e.preventDefault();
                if (isMobile && window?.cordova?.InAppBrowser) {
                    openSystemBrowser(url);
                } else {
                    window.open(url, "_blank");
                }
                return;
            }
            
            const btn = e.target.closest('[data-href],[data-url]');
            if (btn) {
                const url = btn.dataset.href || btn.dataset.url;
                if (url) {
                    e.preventDefault();
                    if (isMobile && window?.cordova?.InAppBrowser) {
                        openSystemBrowser(url);
                    } else {
                        window.open(url, "_blank");
                    }
                }
            }
        };

        container.addEventListener('click', handleLinkClick);
        return () => container.removeEventListener('click', handleLinkClick);
    }, [isMobile]);

    if (!bannerContent) {
        return null;
    }

    return (
        <div ref={containerRef}>
            <div dangerouslySetInnerHTML={{__html: bannerContent}}/>
        </div>
    )
}

export default BannerHTMLComponent;
